import React, { useEffect } from "react";
import styles from "./styles.module.scss";
import GroupHeader from "app/routes/Groups/_components/GroupHeader";
import ChannelsList from "app/routes/Groups/_components/ChannelsList";
import GettingStartedProgress from "app/components/GettingStarted/GettingStartedProgress";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchGroupById } from "app/actions/groups";
import { clearTeamGroup } from "app/actions/team-group";
import { RootState } from "typedefs";

interface Props {
  children: React.ReactNode;
}

const GroupPageLayout = ({ children }: Props) => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();

  const selectedGroup = useSelector(
    (state: RootState) => state.groups?.selectedGroup,
    shallowEqual,
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchGroupById(id));
    }

    return () => {
      dispatch(clearTeamGroup());
    };
  }, [id, dispatch]);

  return (
    <div className="group-container">
      <GettingStartedProgress />
      <div className={styles.container}>
        <GroupHeader
          title={selectedGroup?.name}
          sport={selectedGroup?.sport}
          avatar={selectedGroup?.logo}
        />
        <div className={styles.timeline_wrapper}>
          <div className={styles.channels_list}>
            <ChannelsList />
          </div>
          <div className={styles.content_container}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default GroupPageLayout;
